import { render, staticRenderFns } from "./TrackChangeCompilations.vue?vue&type=template&id=15059001&"
import script from "./TrackChangeCompilations.vue?vue&type=script&lang=ts&"
export * from "./TrackChangeCompilations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports